import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge can't classify custom tokens on its own: it would read
 * text-bun-body (a font-size) as a color and drop whichever text-* class
 * came first, and read font-book / font-strong (weights 450/550) as font
 * FAMILIES that conflict with font-instrument. Register them explicitly so
 * size + color + family + weight classes coexist.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["bun-balance", "bun-display", "bun-number", "bun-metric", "bun-heading", "bun-body", "bun-meta", "bun-label"] },
      ],
      "font-weight": [{ font: ["book", "strong"] }],
      rounded: [{ rounded: ["bun-sm", "bun", "bun-lg", "bun-xl"] }],
      shadow: [
        { shadow: ["bun-sm", "bun-raise", "bun-menu", "bun-panel", "bun-toast", "bun-modal", "bun-card", "bun-sheet"] },
      ],
    },
  },
});

/**
 * Joins class names (skipping falsy values) and resolves Tailwind conflicts,
 * so `cn("px-4", condition && "px-2")` yields "px-2" when the condition holds.
 */
export function cn(...classes) {
  return twMerge(classes.filter(Boolean).join(" "));
}
